import { Form, Formik } from "formik";
import { Col, Dropdown, Row } from "react-bootstrap";
import {
  Input as TextInput,
  DatePicker,
  Upload,
  AntTextArea,
  Checkbox,
} from "components/Antd";
import {
  CommonButton,
  ImageElement,
  RippleEffect,
  SweetAlert,
  VideoElement,
} from "components/UiElement";
import Media from "apiEndPoints/Media";
import { useEffect, useState } from "react";
import { dayJsDateFormatter } from "utils";
import { checkValidData } from "components/Formatter";
import dayjs from "dayjs";
import GlobalLoader from "components/UiElement/GlobalLoader";
import { dateFormateWithOutSlash, dobFormate, ext } from "helpers";
import moment from "moment";
import { validation } from "./validation";

export default function StepFormTwo({
  t,
  setDetailModal,
  onSubmit,
  albumPhoto,
  getOnePhoto,
  step2Data,
  onHandleDelete,
  albumLoading,
  loading,
  setAlbumPhoto,
  setStep2Data,
  imageUrl,
  setImageUrl,
  theme,
  subscriptionData,
  setSelectedDate,
  // selectedDate,
  show,
  setShow,
}) {
  const [deleteId, setDeleteId] = useState(null);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  // const [isChecked, setIsChecked] = useState(false);

  const handleDateSelect = (e, props) => {
    setSelectedDate(dayjs(e));
    props.setFieldValue("date", dayJsDateFormatter(e, dobFormate));
  };

  const initialValues = {
    name: albumPhoto?.name || "",
    date: albumPhoto?.date || undefined,
    description: albumPhoto?.description || "",
    memorialAlbumImage: albumPhoto?.memorialAlbumImage || "",
    isDownloadable:
      albumPhoto?.isDownloadable &&
        albumPhoto?.isDownloadable === albumPhoto?.memorialAlbumImage
        ? 1
        : 0 || 0,
  };

  const handleNewAlbum = (resetForm) => {
    setStep2Data(null);
    setAlbumPhoto();
    setImageUrl("");
    resetForm();
  };

  const ratios = {
    theme01: 0.85,
    theme02: 0.91,
    theme03: 0.85,
    theme04: 1.4,
  };

  useEffect(() => {
    if (albumPhoto?.date) setSelectedDate(dayjs(albumPhoto?.date));
  }, [albumPhoto]);

  let imgName = imageUrl?.substring(imageUrl?.lastIndexOf("/") + 1);
  let newImageName = imgName?.substring(0, imgName?.lastIndexOf("-"));
  let extension = imgName?.substring(imgName?.lastIndexOf(".") + 1);

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        validationSchema={validation()}
        onSubmit={(val) => {
          let data = { ...val };
          if (val.date) {
            const parsedDate = moment(val.date, dobFormate); // Parse the date
            if (parsedDate.isValid()) {
              data.date = parsedDate.format(dateFormateWithOutSlash); // Format
            }
          }
          onSubmit(data);
        }}
        enableReinitialize
      >
        {(props) => {
          return (
            <Form className="">
              {" "}
              {albumLoading ? (
                <GlobalLoader />
              ) : (
                <div className="commonCard bg-white">
                  <div className="commonCard_head">
                    <h2 className="mb-0">
                      <span>02</span>
                      {albumPhoto ? "Update Albums" : "Create Albums"}
                    </h2>
                  </div>
                  <Row>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="form-label">
                          {t("text.createMemories.albumName")}
                        </label>
                        <TextInput
                          className="form-control"
                          placeholder={t("text.createMemories.enterAlbumName")}
                          name="name"
                          onChange={(e) => {
                            props.setFieldValue("name", e.target.value);
                            if (albumPhoto) setShow(false);
                          }}
                          maxLength={50}
                        />
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="form-label">
                          {t("text.createMemories.date")}{" "}
                          <span className="form-label-date">[MM-DD-YYYY]</span>
                        </label>
                        <DatePicker
                          placeholder={t("text.createMemories.selectDate")}
                          className="form-control"
                          name="date"
                          suffixIcon={<em className="icon-calendar" />}
                          onSelectChange={(e) => {
                            handleDateSelect(e, props);
                            if (albumPhoto) setShow(false);
                          }}
                          defaultValue={
                            albumPhoto?.date === null ||
                              albumPhoto?.date === undefined
                              ? undefined
                              : dayjs(albumPhoto?.date)
                          }
                          validation
                          disabledDate={(current) => {
                            return current && current > dayjs().endOf("day");
                          }}
                        />
                      </div>
                    </Col>
                    <Col sm={12}>
                      <label className="form-label">Description</label>
                      <Row>
                        <Col md={7} lg={8}>
                          <div className="form-group">
                            <AntTextArea
                              placeholder={t("text.createMemories.typeHere")}
                              name="description"
                              className="form-control textareaCustom step2Text"
                              style={{ resize: "none" }}
                              setFieldValue={props.handleChange}
                              maxLength={250}
                              onChange={(e) => {
                                props.setFieldValue(
                                  "description",
                                  e.target.value
                                );
                                if (albumPhoto) setShow(false);
                              }}
                            />
                          </div>
                        </Col>
                        <Col md={5} lg={4}>
                          <div className="form-group">
                            {/* <label className='form-label'>Upload Thumbnail</label> */}
                            <div className="customUpload customUpload-thumb customUpload-w100 uploadThumb">
                              <Upload
                                applyImageCropper={false}
                                type="file"
                                setFieldValue={props.handleChange}
                                // imageUrl={imageUrl}
                                setImageUrl={setImageUrl}
                                validateFileType={[
                                  "image/jpeg",
                                  "image/png",
                                  "image/jpg",
                                ]}
                                name="memorialAlbumImage"
                                validateStatus
                                subscriptionData={subscriptionData}
                                apiEndPoints={Media.mediaUpload(
                                  "album",
                                  "image"
                                )}
                                defaultImageUrl={
                                  albumPhoto?.memorialAlbumImageUrl
                                }
                                aspect={ratios?.[theme]}
                                query
                                setShow={() => {
                                  if (albumPhoto) setShow(false);
                                }}
                              >
                                {imageUrl ? (
                                  <> {`${newImageName}.${extension}`}</>
                                ) : (
                                  <div className="d-flex justify-content-center align-items-center px-2 flex-wrap">
                                    <em className="icon-upload me-2" />
                                    <span className="fw-medium customUpload_txt">
                                      Upload Album Thumbnail Image
                                    </span>
                                  </div>
                                )}
                              </Upload>
                            </div>
                          </div>
                        </Col>{" "}
                      </Row>
                    </Col>

                    <Col md={12} className="d-flex">
                      <div>
                        <Checkbox
                          name="isDownloadable"
                          defaultChecked={
                            albumPhoto &&
                              albumPhoto?.isDownloadable &&
                              albumPhoto?.isDownloadable ===
                              albumPhoto?.memorialAlbumImage
                              ? 1
                              : 0 || 0
                          }
                          setShow={albumPhoto && setShow}
                        >
                          {"   "} Please Check to make Images downloadable.
                        </Checkbox>
                      </div>
                    </Col>
                    {!show && (
                      <Col className="mt-2 text-end">
                        <RippleEffect>
                          <CommonButton
                            type="submit"
                            className="ms-auto"
                            variant="danger"
                            loading={loading}
                          >
                            {albumPhoto
                              ? t("text.common.update")
                              : t("text.common.submit")}
                          </CommonButton>
                        </RippleEffect>
                      </Col>
                    )}
                  </Row>
                </div>
              )}
              {(step2Data || albumPhoto) && (
                <div className="commonCard bg-white">
                  <div className="commonCard_head">
                    <h2 className="mb-0">Uploaded Memories</h2>
                  </div>
                  <Row className="g-3 gy-sm-4">
                    {albumPhoto?.albumPhotos?.length > 0 &&
                      albumPhoto?.albumPhotos?.map((item, index) => {
                        return (
                          <Col sm={6} md={6} lg={4} key={index}>
                            <div className="uploadProfileCard d-flex flex-wrap justify-content-between position-relative">
                              <div className="uploadProfileCard_imgbox">
                                {ext?.[
                                  item?.albumImageUrl?.split(".").pop()
                                ] === "image" && (
                                    <ImageElement
                                      previewSource={item?.albumImageUrl}
                                      alt="thumb-img02"
                                    />
                                  )}
                                {ext?.[
                                  item?.albumImageUrl?.split(".").pop()
                                ] === "file" && (
                                    <span className="pdfUploaded">
                                      <em className="icon-pdf" />
                                    </span>
                                  )}
                                {ext?.[
                                  item?.albumImageUrl?.split(".").pop()
                                ] === "audio" && (
                                    <span className="audioUploaded">
                                      <em className="icon-mic" />
                                    </span>
                                  )}
                                {ext?.[
                                  item?.albumImageUrl?.split(".").pop()
                                ] === "video" && (
                                    <>
                                      <VideoElement
                                        previewSource={item?.albumImageUrl}
                                        alt="thumb-img02"
                                        extraClassName="w-100"
                                        autoPlay={false}
                                        controls={false}
                                      />{" "}
                                      <span className="video">
                                        <em className="icon-video" />
                                      </span>
                                    </>
                                  )}
                              </div>
                              <div className="uploadProfileCard_rightbox position-relative">
                                <div className="uploadProfileCard_rightbox_detail">
                                  <span className="date d-block">
                                    {dayJsDateFormatter(
                                      item?.date,
                                      "MMM DD, YYYY"
                                    )}
                                  </span>
                                  <h3>{checkValidData(item?.title)}</h3>
                                  <span className="location">
                                    <em className="icon-location me-1" />
                                    {checkValidData(item?.location)}
                                  </span>
                                  <p className="">
                                    {checkValidData(item?.description)}
                                  </p>
                                </div>
                                <Dropdown className="d-flex justify-content-center align-items-center uploadProfileCard_dropdown">
                                  <Dropdown.Toggle className="aboutSecDetail_social_icon p-0 border-0">
                                    <em className="icon-more-vertical" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="p-0">
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() => {
                                        setDetailModal(true);
                                        getOnePhoto(item?.id);
                                      }}
                                    >
                                      Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() => {
                                        setIsAlertVisible(true);
                                        setDeleteId(item?.id);
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </Col>
                        );
                      })}

                    <Col sm={6} md={6} lg={4}>
                      <div className="customUpload customUpload-icon customUpload-w100 customUpload-addImg h-100">
                        {/* <Upload> */}
                        <CommonButton
                          className="uploadModal"
                          onClick={() => setDetailModal(true)}
                        >
                          <div className="uploadModal_inner d-flex justify-content-center align-items-center">
                            <span>+ Add Photo, Pdf, Audio or Video</span>
                          </div>
                        </CommonButton>
                        {/* </Upload> */}
                      </div>
                    </Col>
                    <Col sm={12} className="text-end">
                      <RippleEffect>
                        <CommonButton
                          onClick={() => {
                            handleNewAlbum(props.resetForm);
                            props.setFieldValue("date", undefined);
                            setSelectedDate(null);
                            setShow(false);
                            props.setFieldValue("isDownloadable", Number(0));
                          }}
                          variant="danger"
                        >
                          New Album
                        </CommonButton>
                      </RippleEffect>
                    </Col>
                  </Row>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>{" "}
      <SweetAlert
        reverseButtons
        title="Delete Photos"
        text="Are you sure want to delete?"
        show={isAlertVisible}
        icon="warning"
        showCancelButton
        cancelButtonText="No"
        confirmButtonText="Yes"
        confirmButtonColor="#fcb040"
        setIsAlertVisible={setIsAlertVisible}
        showLoaderOnConfirm
        // loading={loading}
        onConfirmAlert={() => {
          onHandleDelete(deleteId);
        }}
      />
    </>
  );
}
